const CANCELED_ERROR_NAMES = new Set(['AbortError', 'CanceledError']);
const CANCELED_ERROR_CODE = 'ERR_CANCELED';

const isObjectRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null;

const isCanceledLike = (error: unknown): boolean => {
    if (error instanceof Error && CANCELED_ERROR_NAMES.has(error.name)) {
        return true;
    }

    if (!isObjectRecord(error)) {
        return false;
    }

    if (typeof error.name === 'string' && CANCELED_ERROR_NAMES.has(error.name)) {
        return true;
    }

    if (error.code === CANCELED_ERROR_CODE) {
        return true;
    }

    if (error.__CANCEL__ === true) {
        return true;
    }

    return typeof error.message === 'string' && error.message.trim().toLowerCase() === 'canceled';
};

export const isRequestCanceled = (error: unknown) => {
    const queue: unknown[] = [error];
    const visited = new Set<unknown>();
    let inspected = 0;
    const MAX_INSPECTED_ITEMS = 12;

    while (queue.length && inspected < MAX_INSPECTED_ITEMS) {
        const current = queue.shift();
        if (current === undefined || current === null || visited.has(current)) {
            continue;
        }

        visited.add(current);
        inspected += 1;

        if (isCanceledLike(current)) {
            return true;
        }

        if (isObjectRecord(current)) {
            queue.push(current.cause, current.error, current.reason);
        }
    }

    return false;
};
